// ...existing code...

import axios from 'axios';
import { User, FileMetadata } from '../types';

const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const login = async (username: string, password: string) => {
  const response = await apiClient.post('/auth/login', { username, password });
  return response.data;
};

export const refreshToken = async (refreshToken: string) => {
  const response = await apiClient.post('/auth/refresh', { refreshToken });
  return response.data;
};

export const logout = async (): Promise<void> => {
  await apiClient.post('/auth/logout');
};

// User API
export const fetchUsers = async (): Promise<User[]> => {
  const response = await apiClient.get('/users');
  return response.data;
};

export const fetchUser = async (username: string): Promise<User> => {
  const response = await apiClient.get(`/users/${username}`);
  return response.data;
};

export const createUser = async (userData: User): Promise<User> => {
  const response = await apiClient.post('/users', userData);
  return response.data;
};

export const updateUser = async (username: string, userData: User): Promise<User> => {
  const response = await apiClient.put(`/users/${username}`, userData);
  return response.data;
};

export const deleteUser = async (username: string): Promise<void> => {
  await apiClient.delete(`/users/${username}`);
};

// File API
export const listFiles = async (
  path: string,
  pattern: string,
  page: number,
  pageSize: number,
  recursive: boolean
): Promise<FileMetadata[]> => {
  const response = await apiClient.get('/files', {
    params: { path, pattern, page, pageSize, recursive },
  });
  return response.data;
};

export const createDirectory = async (path: string): Promise<void> => {
  const response = await apiClient.post('/files/dir', { path });
  return response.data;
};

export const uploadFileInit = async (): Promise<{ uploadId: string }> => {
  const response = await apiClient.post('/files/upload/init');
  return response.data;
};

export const uploadFileChunk = async (uploadId: string, index: number, data: any): Promise<void> => {
  const response = await apiClient.post('/files/upload/chunk', { uploadId, index, data });
  return response.data;
};

export const uploadFileComplete = async (targetPath: string): Promise<void> => {
  const response = await apiClient.post('/files/upload/complete', { targetPath });
  return response.data;
};

export const downloadFile = async (path: string): Promise<Blob> => {
  const response = await apiClient.get('/files/download', { params: { path }, responseType: 'blob' });
  return response.data;
};

export const deleteFile = async (path: string): Promise<void> => {
  await apiClient.delete('/files', { params: { path } });
};

export async function fetchFiles(path: string) {
  // Example implementation
  const response = await fetch(`/api/files?path=${encodeURIComponent(path)}`);
  if (!response.ok) throw new Error('Failed to fetch files');
  return response.json();
}


const apiExports = {
  login,
  refreshToken,
  logout,
  fetchUsers,
  fetchUser,
  createUser,
  updateUser,
  deleteUser,
  listFiles,
  createDirectory,
  uploadFileInit,
  uploadFileChunk,
  uploadFileComplete,
  downloadFile,
  deleteFile,
  fetchFiles,
};
export default apiExports;